module.exports = {"title":"联系我","layout":"page","path":"/contact","body":"<p><i class=\"fa fa-envelope-o\"></i> \n<a href=\"mailto:lshinylee007@gmail.com\" style=\"color: #444\">lshinylee007@gmail.com</a></p>\n"}


//////////////////
// WEBPACK FOOTER
// ./pages/contact/index.md
// module id = 517
// module chunks = 0